import Model from './../../common/Model';

class Start extends Model {

	static fieldsInternal() {
		return ['jockey', 'owner', 'trainer', 'horse', 'breeder', 'post_position', 'program_number', 'odds',
			'scratched', 'finish_position', 'win_payoff', 'place_payoff', 'show_payoff'];
	}

}

export default Start;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/store/Start.js
 **/